import {
  ArrowUpRight,
  Globe,
  PencilSimple,
  Trash,
} from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";

import useAgencyDomain from "../../../datahooks/useAgencyDomain";
import useAgencyDomainConfiguration from "../../../datahooks/useAgencyDomainConfiguration";

export default function DomainItem({
  domainName,
  ...rest
}: {
  domainName: string;
} & ({ onDelete: () => void } | { onEdit: () => void })) {
  const { agencyDomain } = useAgencyDomain(domainName);
  const { agencyDomainConfiguration } =
    useAgencyDomainConfiguration(domainName);

  const isLive =
    agencyDomain?.verified &&
    agencyDomainConfiguration &&
    !agencyDomainConfiguration.misconfigured;

  const canDelete = "onDelete" in rest;

  return (
    <div className="flex justify-between">
      <div className="flex items-center gap-x-1">
        <Globe size={16} />
        <span className="text-xs-medium text-black-500">{domainName}</span>
        <Button size="xs" intent="iconOnly" variant="ghost-black" asChild>
          <Link to={`https://${domainName}`} target="_blank">
            <ArrowUpRight />
          </Link>
        </Button>
        {isLive && (
          <Tag size="sm" variant="success">
            Live
          </Tag>
        )}
      </div>
      {canDelete && (
        <Button
          size="xs"
          intent="iconOnly"
          variant="ghost-black"
          onClick={rest.onDelete}
          aria-label={canDelete ? "delete domain" : "edit domain"}
        >
          {canDelete ? <Trash /> : <PencilSimple />}
        </Button>
      )}
    </div>
  );
}
